import { render, staticRenderFns } from "./abroad-industry.vue?vue&type=template&id=cd19c9ae&scoped=true&"
import script from "./abroad-industry.vue?vue&type=script&lang=js&"
export * from "./abroad-industry.vue?vue&type=script&lang=js&"
import style0 from "./abroad-industry.vue?vue&type=style&index=0&id=cd19c9ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd19c9ae",
  null
  
)

export default component.exports